import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { isEmpty } from 'lodash';
import Header from './Header/Header';
import Dropdown from '../Dropdown';
import Checkbox from '../Checkbox/Checkbox';
import { LOCKSMITH_OCCUPATION_ID } from '../../utils/constants';

import styles from './index.module.scss';

function Step2({
  byCategory, data, next, setState, getState, current, size, services, handleClose
}) {
  const [selectedServices, setSelectedServices] = useState(getState('service', []));

  const selectedSkill = services.find((item) => item.job_service_id === selectedServices[0]);
  const categoryName = selectedSkill && selectedSkill.job_sub_category_name;
  const [selectedCategory, setSelectedCategory] = useState(categoryName);

  const categories = Object.keys(byCategory);
  const service = byCategory[selectedCategory] || [];

  const subCategoryId = selectedCategory && service[0].job_sub_category_id;
  const occupationId = data.occupation_id;

  if (occupationId !== LOCKSMITH_OCCUPATION_ID) {
    next();
  }

  useEffect(() => {
    setState('subCategoryId', subCategoryId);
    if (selectedCategory !== categoryName) {
      setSelectedServices([]);
    }
  }, [selectedCategory]);

  useEffect(() => {
    if (isEmpty(selectedServices)) {
      setState('service', []);
    }
  }, [selectedServices]);

  const handleCheckbox = (id) => {
    if (selectedServices.find((el) => el === id)) {
      const newServices = selectedServices.filter((el) => el !== id) || [];
      setSelectedServices(newServices);
      setState('service', newServices);
    } else {
      setSelectedServices([...selectedServices, id]);
      setState('service', ([...selectedServices, id]));
    }
  };

  return (
    <div className={styles.wrapper}>
      <Header current={current} size={size} occupation={data.occupation_name} business={data.business_name} handleClose={handleClose} />
      <div className={styles.body}>
        <p className={styles.title}>What type of service do you require?</p>
        <Dropdown label="Service category" items={categories} onSelect={setSelectedCategory} value={selectedCategory} />
        <div className={styles.checkboxes}>
          {service.map((subcat) => (
            <Checkbox
              onClick={() => handleCheckbox(subcat.job_service_id)}
              key={subcat.job_service_name}
              label={subcat.job_service_name}
              checked={!!selectedServices.find((el) => el === subcat.job_service_id)}
            />
          ))}
        </div>
      </div>
    </div>
  );
}

Step2.propTypes = {
  data: PropTypes.shape({
    occupation_name: PropTypes.string,
    occupation_id: PropTypes.number,
    business_name: PropTypes.string,
    skillset: PropTypes.array,
  }),
  byCategory: PropTypes.object,
  next: PropTypes.func,
  setState: PropTypes.func,
  getState: PropTypes.func,
  current: PropTypes.number,
  size: PropTypes.number,
  services: PropTypes.array,
  handleClose: PropTypes.func,
};

export default Step2;
